export default __webpack_public_path__ + "static/media/warning_error.5d9f08fc.svg";